import SiteLayout from "~/components/layout/SiteLayout";

const TalentRadarPage = () => {
  return (
    <SiteLayout>
      <div>
        <h1>找人雷达</h1>
      </div>
    </SiteLayout>
  );
};

export default TalentRadarPage;
